import React from 'react';
import { Button } from "../../components/ui/button";
import { Rocket } from "lucide-react";

const DhanSignupSection = () => {
    return (
        <section className="py-12 sm:py-20 bg-layer1 text-text animate-slide-up bg-white/5">
            <div className="container">
                <div className="flex flex-col gap-8 max-w-6xl mx-auto">
                    <div className="space-y-5 text-center sm:text-left">
                        <h2 className="text-3xl sm:text-4xl font-bold leading-tight">
                            Ready to get <span className="text-market-teal">3 Additional Free Months</span> of marketpulse.exchange?
                        </h2>
                        <p className="text-base sm:text-lg text-gray-400">
                            Open your DHAN account now and get instant access to premium features worth ₹1749.
                        </p>
                        <div className="flex items-start sm:items-center gap-3 text-subText justify-center sm:justify-start">
                            <Rocket className="w-5 h-5 text-market-teal mt-1 flex-shrink-0" />
                            <span className="text-sm sm:text-base">
                                Free TradingView Premium Features and Seamless API & Tools for Intraday Traders
                            </span>
                        </div>
                    </div>

                    <div className="flex justify-center sm:justify-start">
                        <Button
                            className="bg-market-teal hover:bg-market-teal/90 text-black font-semibold text-base sm:text-lg px-6 py-4 sm:px-8 sm:py-5 rounded-xl shadow-md transition"
                            asChild
                        >
                            <a
                                href="https://invite.dhan.co/?join=UTVA03~OPT"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Open Account Now
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DhanSignupSection;
